<template>
  <div class="archivesCenter">
    <div class="options">
      <div>
        <el-upload
          class="upload-demo"
          action
          :http-request="uploadFile"
          ref="upload"
          :show-file-list="false"
        >
          <div class="add_document">+新增文档</div>
        </el-upload>
      </div>
      <div class="exporting_documents" @click="exportingDocuments">导出文档</div>
      <div class="remove_documents" @click="removeDocuments">删除文档</div>
    </div>
    <div class="table_data">
      <el-table
        ref="multipleTable"
        :data="tableData"
        height="calc(100vh - 464px)"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ color: '#333333' }"
        @sort-change="changeTableSort"
      >
        <el-table-column align="center" type="selection" width="100"> </el-table-column>
        <el-table-column align="center" label="序号">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>

        <el-table-column align="center" label="文档名称">
          <template slot-scope="scope">
            <div class="documents_name">{{ scope.row.documentName | documentName }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="文档类型" width="230">
          <template slot-scope="scope">{{ scope.row.documentType }}</template>
        </el-table-column>

        <el-table-column align="center" label="上传人">
          <template slot-scope="scope">{{ scope.row.createName }}</template>
        </el-table-column>

        <el-table-column
          align="center"
          label="上传时间"
          prop="上传时间"
          sortable="custom"
          @sort-change="changeTableSort"
        >
          <template slot-scope="scope">{{ scope.row.createTime }}</template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="150px">
          <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          <template slot-scope="scope">
            <div class="table_options">
              <div class="examine" @click="clickExamine(scope.row)">查看</div>
              <div>
                <el-upload
                  class="upload-demo"
                  action
                  :http-request="uploadFileReplace"
                  ref="uploadReplace"
                  :show-file-list="false"
                >
                  <div class="replace" @click="clickReplace(scope.row.id)">替换</div>
                </el-upload>
              </div>
              <div class="remove_item" @click="clickRemoveItem(scope.row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination_box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getArchivesCenter,
  deleteArchivesCenter,
  uploadAdmin,
  saveArchivesCenter,
  uploadFile,
  updateArchivesCenter
} from '@/api/projectCenter.js'
const defaultQueryInfo = Object.freeze({
  pageNum: 1,
  pageSize: 10,
  projectId: 0
})
export default {
  components: {},
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      query: { ...defaultQueryInfo },
      replaceId: null,
      total: 0
    }
  },

  computed: {
    item() {
      return JSON.parse(this.$route.query.item)
    }
  },

  watch: {},
  created() {
    this.search()
    console.log(this.item)
  },
  filters: {
    // 过滤文件名字前面的test/
    documentName: function (val) {
      return val.replace(/test\//g, '')
    }
  },
  methods: {
    // 导出文档
    exportingDocuments() {
      if (this.multipleSelection == [] || this.multipleSelection.length == 0) {
        return this.$message('请选择要导出的文档')
      }

      this.multipleSelection.forEach(async (item, index) => {
        let query = {
          urlStr: item.documentUrl
        }
        const { data: res } = await uploadFile(query)
        let str = item.documentName.split('/')
        if (res) {
          let blob = new Blob([res])
          let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载'链接
          // a.download = item.documentName.replace(/test\//g, '') //指定下载文件名
          a.download = str[1].split('.')[0] + '.doc' //指定下载文件名
          // a.download = "test.png";
          a.click() //触发下载
          window.URL.revokeObjectURL(a.href) //释放URL对象
          if (document.body.contains(a)) {
            document.body.removeChild(a) //释放标签
          }
        }
        // else {
        //   this.$message.error('导出失败!')
        // }
      })
    },

    //多个 删除文档
    async removeDocuments() {
      if (this.multipleSelection == [] || this.multipleSelection.length == 0) {
        return this.$message('请选择要删除的文档')
      }
      let id = []
      this.multipleSelection.forEach((item, index) => {
        id.push(item.id)
      })
      console.log('remove')
      const { data: res } = await deleteArchivesCenter(id)
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
    },
    // 删除单个文档
    async clickRemoveItem(row) {
      let id = []
      id.push(row.id)
      console.log('remove')
      const { data: res } = await deleteArchivesCenter(id)
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
    },
    // 查看当前文档
    clickExamine(row) {
      window.open(row.documentUrl, '_blank')
    },
    handleSelectionChange(val) {
      // val 选中数据的集合
      this.multipleSelection = val
      console.log(this.multipleSelection)
      console.log(val)
    },
    changeTableSort(column) {
      // console.log(column)
      if (column.order == 'ascending') {
        console.log('11')
      } else if (column.order == 'descending') {
        console.log('22')
      } else if (column.order == null) {
        console.log('33')
      }
    },
    //
    async search() {
      this.query.projectId = this.item.id
      const { data: res } = await getArchivesCenter(this.query)
      if (res.resultCode == 200) {
        console.log(res.data)
        this.tableData = res.data.list
        this.total = res.data.total
      }
    },
    // 分页
    handleSizeChange(val) {
      this.query.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      this.search()
    },
    initDay() {
      const date = new Date() // 得到当前时间
      const year = date.getFullYear() // 年
      const mont = date.getMonth() + 1 // 月
      const dat = date.getDate() // 日
      const hour = date.getHours() // 时
      const minute = date.getMinutes() // 分
      const second = date.getSeconds() // 秒
      const hours = hour < 10 || hour === 0 ? '0' + hour : hour // 时
      const minutes = minute < 10 ? '0' + minute : minute // 分
      const seconds = second < 10 ? '0' + second : second // 秒
      return `${year}-${mont}-${dat} ${hours}:${minutes}:${seconds}`
    },
    // 上传文档
    async uploadFile(file) {
      //上传文件的需要formData类型;所以要转
      let form = new FormData()
      form.append('files', file.file)
      const { data: res } = await uploadAdmin(form)

      if (res.resultCode == 200) {
        let query = {
          createName: sessionStorage.getItem('userName'), // 上传人
          createTime: this.initDay(), // 上传时间
          documentName: res.data.fileAddr[0].split('-').slice(1).join('-'), // 文档名称
          documentUrl: res.data.fileLook[0], // 文档路径
          id: 0, // 主键
          projectId: this.item.id, //  项目id
          remark: '' // 备注
        }
        const { data: resS } = await saveArchivesCenter(query)
        if (resS.resultCode == 200) {
          this.$message.success('新增成功')
          this.search()
        }
      }
    },
    clickReplace(id) {
      this.replaceId = null
      this.replaceId = id
    },
    // 替换文档
    async uploadFileReplace(file, id) {
      //上传文件的需要formData类型;所以要转
      let form = new FormData()
      form.append('files', file.file)
      const { data: res } = await uploadAdmin(form)

      if (res.resultCode == 200) {
        let query = {
          createName: sessionStorage.getItem('userName'), // 上传人
          createTime: this.initDay(), // 上传时间
          documentName: res.data.fileAddr[0].split('-').slice(1).join('-'), // 文档名称
          documentUrl: res.data.fileLook[0], // 文档路径
          id: this.replaceId, // 主键
          projectId: this.item.id, //  项目id
          remark: '' // 备注
        }
        const { data: resS } = await updateArchivesCenter(query)
        if (resS.resultCode == 200) {
          this.$message.success('替换成功')
          this.search()
        }
      }
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.archivesCenter {
  .options {
    height: 92px;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding-left: 37px;

    .add_document {
      width: 89px;
      height: 36px;
      color: #fff;
      background-color: #17757a;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin-right: 22px;
      cursor: pointer;
    }
    .exporting_documents {
      width: 89px;
      height: 36px;
      color: #fff;
      background-color: #17757a;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin-right: 22px;
      cursor: pointer;
    }
    .remove_documents {
      width: 89px;
      height: 36px;
      color: #17757a;
      background-color: #fff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      border: 1px solid #17757a;
      cursor: pointer;
    }
  }
  .table_data {
    background-color: #fff;
    padding: 0 49px 0 27px;
    .table_options {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 14px;
      .examine {
        color: #17757a;
        cursor: pointer;
      }
      .replace {
        color: #17757a;
        cursor: pointer;
      }
      .remove_item {
        cursor: pointer;
        color: #fa5050;
      }
    }
    .documents_name {
      color: #4a6aed;
      font-size: 14px;
    }
  }
  .pagination_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
  }
}
</style>
